/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  Checkbox,
  HStack,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { DiskContext } from '../context';
import { FileFolderIcon } from '../my-disk/file-icon';
import moment from 'moment';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const DiskBinModal = forwardRef(({ ...props }, ref) => {
  const {
    binFiles,
    getBinFiles,
    restoreFileFolder,
    selectedFile,
    binDisc,
    restoreFileFolderLoading,
    permenantDeleteFileFolder,
    permenantDeleteFileFolderLoading
  } = useContext(DiskContext);
  const [selected, setSelected] = useState([]);
  useEffect(() => {
    getBinFiles();
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = () => {
    restoreFileFolder({ file: selected });
  };

  const onSelect = (file) => (e) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    if (selected.find((f) => f?.id === file?.id)) {
      const selected_ = selected?.filter((file_) => file_?.id !== file?.id);
      setSelected(selected_);
    } else {
      selected.push(file);
      setSelected([...selected]);
    }
  };

  const { t } = useTranslator();
  const direction = useDirection();
  const deletePermanant = () => {
    permenantDeleteFileFolder({ file: selected });
  }

  return (
    <>
      <Modal size="2xl" {...binDisc}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
            <ModalHeader>
              <Text fontWeight="400">{t('otherModules.selectedFilesRestored') || "Selected files will be restored"}</Text>
            </ModalHeader>
            <ModalBody maxH="70vh" overflowY="auto">
              {binFiles?.length ? (
                <List>
                  {binFiles?.map?.((file, findex) => (
                    <ListItem
                      p={2}
                      _hover={{ bg: 'brandGray.500' }}
                      key={findex}
                      as={HStack}
                      onClick={onSelect(file)}
                      borderRadius={"full"}
                      cursor="pointer"
                      justifyContent="space-between"
                    >
                      <HStack>
                      <Checkbox
                        border="1px solid #00000033"
                        borderRadius="5"
                        onClick={onSelect(file)}
                        isChecked={
                          selected?.findIndex?.((f) => f.id === file.id) > -1
                        }
                      />
                      <FileFolderIcon file={file} width={32} height={32} />
                      <Text maxW="64" truncate>
                        {file?.name}
                      </Text>
                      </HStack>
                      <Text maxW="64" truncate>
                        {moment(file?.updated_at).format('MM-DD-YYYY hh:mm:ss')}
                      </Text>
                    </ListItem>
                  ))}
                </List>
              ) : (
                `${t('otherModules.noDeletedFilesFound') || "No deleted files found"}...`
              )}

              
            </ModalBody>
            <ModalFooter justifyContent="space-between">
            <Button borderRadius="30px" isDisabled={((binFiles?.length === 0) || (selected?.length <= 0))} variant={((binFiles?.length === 0) || (selected?.length <= 0)) ? "" : "secondary"} type="button" onClick={() => deletePermanant()} isLoading={permenantDeleteFileFolderLoading}>{t('otherModules.permanentlyDelete') || "Permanently delete"}</Button>
              <Button
                isLoading={restoreFileFolderLoading}
                type="submit"
                variant="primary"
                isDisabled={selected?.length <= 0}
                borderRadius="30px"
              >
                {t('otherModules.restore') || "Restore"}
              </Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
});
